import { useSelector } from 'react-redux';
import { hasTradeIn } from '../activeDeal/selector';
import type { TradeInOverview } from './types';
import { TRADE_IN_DEALER_APPRAISAL_SOURCE, TRADE_IN_RECORD_LABEL } from '@makemydeal/dr-sales-checkin-types';

type TradeInSource = 'KBB' | 'Manual Entry' | 'ICO';

export const useTradeInComponent = () => {
    return useSelector((state: any) => state.tradeInComponent || {});
};

export const getTradeInSource = (state: any): TradeInSource => {
    const source = state.tradeInComponent?.source;

    const sourceMap: Record<string, TradeInSource> = {
        SD: 'KBB',
        USER: 'Manual Entry'
    };

    return sourceMap[source] || (source as TradeInSource);
};

export const isTradeInCompleted = (state: any): boolean => state.tradeInComponent?.isCompleted ?? false;

export const getTradeInOverview = (state: any): TradeInOverview | undefined => {
    const tradeInComponent = state.tradeInComponent;

    if (!hasTradeIn(state) || !tradeInComponent?.isCompleted) {
        return undefined;
    }

    const { vehicle, source, value, amountOwed } = tradeInComponent;
    const vehicleName = [vehicle?.year, vehicle?.make?.name, vehicle?.model?.name]
        .map((part) => (part == null ? '' : `${part}`.trim()))
        .filter((part) => part && part !== 'undefined')
        .join(' ');

    return {
        label: TRADE_IN_RECORD_LABEL,
        vehicleName,
        appraisalStatus: source === TRADE_IN_DEALER_APPRAISAL_SOURCE ? 'APPRAISED' : 'PENDING',
        mileage: vehicle?.mileage,
        estimatedValue: value,
        payoff: amountOwed ?? 0
    };
};
